<template>
<!-- 使用人信息 -->
    <div>
        <!-- <div class="search">
            <input v-model="myfiles.myfilephone" class="searchInput" maxlength="11" pattern="[0-9]" type="text" name="phone" placeholder="通过手机号进行搜索">
            <img @click="change" class="searchImg" src="../assets/icon_sousu@2x.png" alt="">
        </div> -->
        <div class="top">
            <router-link :to="{name: 'NewUser'}">
                <button>新建联系人 <span>+</span></button>
            </router-link>

            <div class="tips">(仅限一人使用)</div>
        </div>
        <div class="title">
            <span>使用人</span>
            <span>手机号</span>
            <span>个人信息</span>
            <span>眼部档案</span>
        </div>
        <div class="list">
            <div class="title userList" v-for="item in myfiles" :key="item.index">
                <span> {{ item.myfilename }} </span>
                <span> {{ item.myfilephone }} </span>
                <span>
                    <router-link class="searchLink" :to="{name: 'SeeUser', params: { myfileid: item.myfileid }}">
                        查看
                    </router-link>
                </span>
                <span>
                    <router-link class="searchLink" :to="{name: 'SeeEyeHealth', params: { myfilename: item.myfilename, myfileid: item.myfileid }}">
                        查看
                    </router-link>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            myfiles: [],
            searchPhone: '',
            myfileid: '',

        };
    },
    computed: {

    },
    created() {
        this.getUserList()
    },
    mounted() {

    },
    watch: {

    },

    methods: {
        getUserList() {
            this.axios.get('/weixin/getMyfile')
            .then(res=>{
                this.myfiles = res.data

            })
        },

       /* change() {
            this.axios.get('/j3m/weixin/tomyfile.action', {
                params: {
                    myfilephone: this.myfiles.myfilephone
                }
            })
            .then(res=>{
                this.myfiles = res.data.myfiles
            })
        }*/
    },
    components: {

    },
};
</script>

<style scoped>
.searchLink {
    color: #eac645;
}
button {
  width: 40%;
  height: 100px;
  letter-spacing: 4px;
  background-color: #eac645;
  color: #fff;
  border-radius: 25px;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.top {
    text-align: center;
    background: #f8f8f8;
    padding: 30px 0 34px;
}

.top button {
    font-size: 38px;
    display: block;
    margin: 0px auto 23px;
}

.top button span {
    color: #fff;
    position: relative;
    top: -4px;
    left: 10px;
}

.list {
    padding: 0 28px;
    background: #fff;
}

.title {
    background: #fff;
    font-size: 34px;
    height: 90px;
    line-height: 90px;
    color: #333;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f0f0f0;
}
.userList {
    font-size: 34px;
}
.title span {
    text-align: center;
    width: 33.3333%;
    overflow-x: auto;
}

.search {
    padding: 28px;
    position: relative;
}
.search .searchInput {
    width: 100%;
    height: 76px;
    line-height: 66px;
    border: none;
    border-radius: 100px;
    text-indent: 28px;
    text-align: center;

}
.searchImg {
    position: absolute;
    width: 76px;
    right: 28px;
    top: 28px;
}

.tips {
    font-size: 34px;
    color: #999;
}
</style>



// WEBPACK FOOTER //
// src/views/UserInformation.vue